/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PageInputDto model module.
 * @module model/PageInputDto
 * @version v0
 */
class PageInputDto {
    /**
     * Constructs a new <code>PageInputDto</code>.
     * Page object to create
     * @alias module:model/PageInputDto
     * @param type {String} 
     * @param categoryId {Number} 
     * @param title {String} 
     * @param body {String} 
     */
    constructor(type, categoryId, title, body) { 
        
        PageInputDto.initialize(this, type, categoryId, title, body);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, type, categoryId, title, body) { 
        obj['type'] = type;
        obj['category_id'] = categoryId;
        obj['title'] = title;
        obj['body'] = body;
    }

    /**
     * Constructs a <code>PageInputDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PageInputDto} obj Optional instance to populate.
     * @return {module:model/PageInputDto} The populated <code>PageInputDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PageInputDto();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('category_id')) {
                obj['category_id'] = ApiClient.convertToType(data['category_id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('body')) {
                obj['body'] = ApiClient.convertToType(data['body'], 'String');
            }
            if (data.hasOwnProperty('interpretation')) {
                obj['interpretation'] = ApiClient.convertToType(data['interpretation'], 'String');
            }
            if (data.hasOwnProperty('video_link')) {
                obj['video_link'] = ApiClient.convertToType(data['video_link'], 'String');
            }
            if (data.hasOwnProperty('audio_link')) {
                obj['audio_link'] = ApiClient.convertToType(data['audio_link'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PageInputDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PageInputDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PageInputDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['body'] && !(typeof data['body'] === 'string' || data['body'] instanceof String)) {
            throw new Error("Expected the field `body` to be a primitive type in the JSON string but got " + data['body']);
        }
        // ensure the json data is a string
        if (data['interpretation'] && !(typeof data['interpretation'] === 'string' || data['interpretation'] instanceof String)) {
            throw new Error("Expected the field `interpretation` to be a primitive type in the JSON string but got " + data['interpretation']);
        }
        // ensure the json data is a string
        if (data['video_link'] && !(typeof data['video_link'] === 'string' || data['video_link'] instanceof String)) {
            throw new Error("Expected the field `video_link` to be a primitive type in the JSON string but got " + data['video_link']);
        }
        // ensure the json data is a string
        if (data['audio_link'] && !(typeof data['audio_link'] === 'string' || data['audio_link'] instanceof String)) {
            throw new Error("Expected the field `audio_link` to be a primitive type in the JSON string but got " + data['audio_link']);
        }

        return true;
    }


}

PageInputDto.RequiredProperties = ["type", "category_id", "title", "body"];

/**
 * @member {String} type
 */
PageInputDto.prototype['type'] = undefined;

/**
 * @member {Number} category_id
 */
PageInputDto.prototype['category_id'] = undefined;

/**
 * @member {String} title
 */
PageInputDto.prototype['title'] = undefined;

/**
 * @member {String} body
 */
PageInputDto.prototype['body'] = undefined;

/**
 * @member {String} interpretation
 */
PageInputDto.prototype['interpretation'] = undefined;

/**
 * @member {String} video_link
 */
PageInputDto.prototype['video_link'] = undefined;

/**
 * @member {String} audio_link
 */
PageInputDto.prototype['audio_link'] = undefined;

/**
 * @member {Boolean} enabled
 */
PageInputDto.prototype['enabled'] = undefined;






export default PageInputDto;

